import React from 'react';
import { formatPrice } from '@domain-group/fe-allhomes-library';
import { ArrowLeftIcon } from '@domain-group/fe-co-icon';
import * as styles from './median-price-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MedianPriceCard = _ref => {
  var _ref$statistics = _ref.statistics,
    statistics = _ref$statistics === void 0 ? {} : _ref$statistics,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'vertical' : _ref$appearance,
    _ref$roundels = _ref.roundels,
    roundels = _ref$roundels === void 0 ? false : _ref$roundels,
    _ref$colours = _ref.colours,
    colours = _ref$colours === void 0 ? ['#000000', '#000000'] : _ref$colours,
    _ref$deltas = _ref.deltas,
    deltas = _ref$deltas === void 0 ? false : _ref$deltas;
  var _statistics$houseMedi = statistics.houseMedianPrice,
    houseMedianPrice = _statistics$houseMedi === void 0 ? 0 : _statistics$houseMedi,
    _statistics$unitMedia = statistics.unitMedianPrice,
    unitMedianPrice = _statistics$unitMedia === void 0 ? 0 : _statistics$unitMedia,
    _statistics$unitPrice = statistics.unitPriceYearlyDelta,
    unitPriceYearlyDelta = _statistics$unitPrice === void 0 ? 0 : _statistics$unitPrice,
    _statistics$housePric = statistics.housePriceYearlyDelta,
    housePriceYearlyDelta = _statistics$housePric === void 0 ? 0 : _statistics$housePric;
  if ((!houseMedianPrice || houseMedianPrice === 0) && (!unitMedianPrice || unitMedianPrice === 0)) {
    return null;
  }
  var housePriceFormatted = houseMedianPrice && "$".concat(formatPrice(houseMedianPrice));
  var unitPriceFormatted = unitMedianPrice && "$".concat(formatPrice(unitMedianPrice));
  return ___EmotionJSX("div", {
    css: styles.medianPriceContainer(appearance === 'vertical')
  }, !!houseMedianPrice && houseMedianPrice > 0 && housePriceFormatted && ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.medianPriceTitle
  }, "Median house price"), ___EmotionJSX("div", {
    css: styles.medianPriceBody
  }, ___EmotionJSX("div", {
    css: styles.medianPriceValue
  }, roundels && ___EmotionJSX("div", {
    css: styles.roundel(colours[0])
  }), housePriceFormatted), deltas && ___EmotionJSX("div", {
    css: styles.medianPriceDelta
  }, housePriceYearlyDelta === null || housePriceYearlyDelta === void 0 ? void 0 : housePriceYearlyDelta.toFixed(1), "%", ___EmotionJSX("div", {
    css: styles.medianPriceArrow(!!housePriceYearlyDelta && housePriceYearlyDelta >= 0)
  }, ___EmotionJSX(ArrowLeftIcon, {
    size: "custom",
    css: styles.medianPriceIcon
  }))))), !!unitMedianPrice && unitMedianPrice > 0 && unitPriceFormatted && ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.medianPriceTitle
  }, "Median unit price"), ___EmotionJSX("div", {
    css: styles.medianPriceBody
  }, ___EmotionJSX("div", {
    css: styles.medianPriceValue
  }, roundels && ___EmotionJSX("div", {
    css: styles.roundel(colours[1])
  }), unitPriceFormatted), deltas && ___EmotionJSX("div", {
    css: styles.medianPriceDelta
  }, unitPriceYearlyDelta === null || unitPriceYearlyDelta === void 0 ? void 0 : unitPriceYearlyDelta.toFixed(1), "%", ___EmotionJSX("div", {
    css: styles.medianPriceArrow(!!unitPriceYearlyDelta && unitPriceYearlyDelta >= 0)
  }, ___EmotionJSX(ArrowLeftIcon, {
    size: "custom",
    css: styles.medianPriceIcon
  }))))));
};
export default MedianPriceCard;